import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Component({
  selector: 'emoji-picker',
  templateUrl: './emoji-picker.component.html',
  styleUrls: ['./emoji-picker.component.scss']
})
export class EmojiPickerComponent {

  i18nEmojiMart = {
    search: 'Busca',
    emojilist: 'Lista de emoji',
    notfound: 'Nenhum emoji encontrado',
    clear: 'Limpar',
    categories: {
      search: 'Resultados da busca',
      recent: 'Usados frequentemente',
      people: 'Expressões & Pessoas',
      nature: 'Animais & Natureza',
      foods: 'Comidas & Bebidas',
      activity: 'Atividades',
      places: 'Viajens & Lugares',
      objects: 'Objetos',
      symbols: 'Símbolos',
      flags: 'Bandeiras',
      custom: 'Personalizados',
    },
    skintones: {
      1: 'Tom de pele padrão',
      2: 'Tom de pele branco',
      3: 'Tom de pele moreno claro',
      4: 'Tom de pele mooreno',
      5: 'Tom de pele escuro',
      6: 'Tom de pele negro',
    }
  }

  showEmoji: boolean = false;
  @Output() emojiSelect = new EventEmitter();

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target))
      this.showEmoji = false;
  }

  constructor(private eRef: ElementRef) { }

  onEmojiSelect(emoji) {
    this.emojiSelect.emit(emoji.emoji.native);
  }
}
